// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"52780a4e","55":"410e4935","106":"2084e648","138":"3ad2fd0e","255":"4e956f72","271":"b15fef24","363":"7b7137c6","433":"afc0959f","636":"b49082a8","787":"99cc1204","810":"debf93ef","863":"c716fbba"}[chunkId] + ".chunk.js";
};